<!--
  列表页统计面板的单项

  使用:
  <lc-summary-item label="金额" :content="num(1)">
    <template slot="extra">
      <lc-summary-sub-item />
    </template>
  </lc-summary-item>
 -->
<template>
  <div class="lc-summary-item clearfix" :style="{ flex: flexValue }">
    <!-- 左侧: 主要信息 -->
    <div class="pull-left">
      <!-- Label -->
      <div class="item-label">
        <slot name="label"></slot>
        <span v-if="isEmptyObject($slots.label)">{{ label }}</span>

        <!-- 左侧: 单位 -->
        <span v-if="!isEmptyObject(subLabel)" class="lc-mini-size lc-secondary-color m-l-2">({{ subLabel }})</span>
        <slot name="subLabel"></slot>
      </div>

      <!-- Content -->
      <div class="item-content" :class="`lc-${contentStyleType}-color`">
        <!-- 加载时显示空 -->
        <template v-if="loading">-</template>
        <template v-else
          ><slot name="content">{{ content }}</slot></template
        >
      </div>
    </div>

    <!-- 右侧: 子项 -->
    <div v-if="expanded" class="pull-left m-l-5">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  inject: ['flexValue'], // 获取来自父组件
  // 提供给子组件的属性
  provide() {
    return {
      subLabelWidth: this.subLabelWidth,
      summaryItemBus: this.summaryItemBus
    }
  },
  props: {
    // 标签
    label: {
      type: String,
      default: ''
    },
    /**
     * 副标。如单位
     */
    subLabel: {
      type: String,
      default: ''
    },
    // 内容
    content: {
      type: String,
      default: ''
    },
    // 子项的标签宽度
    subLabelWidth: {
      type: [Number, String],
      default: ''
    },
    // 内容的样式类型：success/info/danger/warning/brand
    contentStyleType: {
      type: String,
      default: 'default'
    },
    // 加载中
    loading: {
      type: Boolean,
      default: false
    },
    // 展开
    expanded: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      summaryItemBus: new Vue()
    }
  },
  watch: {
    loading() {
      this.emitLoadingChangedEvent()
    }
  },
  methods: {
    /**
     * Loading 状态改变事件
     */
    emitLoadingChangedEvent() {
      this.summaryItemBus.$emit('loading-changed', this.loading)
    }
  }
}
</script>

<style lang="scss" scoped>
// Panel
.lc-summary-item {
  flex-direction: column;
  vertical-align: top;
  padding: 0px 25px;

  .item-label {
    white-space: nowrap;
    font-size: 13px;
    font-weight: 500;
    color: #303133;
  }

  .item-content {
    font-family: DINAlternate-Bold;
    font-size: 20px;
    font-weight: bold;
  }
}
</style>
